var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"el",staticClass:"tw-flex tw-flex-row tw-items-center tw-justify-end tw-gap-2 tw-border-t tw-border-outline-light tw-p-4"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }